import type { FC } from "react";
import { Illustration } from "../Illustration";
import { Section } from "../Section";
import {
  Card,
  Container,
  type ContainerProps,
  Flex,
  Heading,
} from "@huub-web/ui";

export type MaximumMortgageWizardResultErrorScreenProps = {
  container?: ContainerProps["size"];
};

export const MaximumMortgageWizardResultErrorScreen: FC<
  MaximumMortgageWizardResultErrorScreenProps
> = ({ container = "marketingS" }) => (
  <Section variant="tint" style={{ minHeight: "100%" }}>
    <Container size={container} grow>
      <Card border="default" overflowHidden>
        <Flex direction="column" gap="xs" align="center">
          <Illustration name="shrug" alt="Mijn excuses" alignSelf="center" />
          <Heading
            variant="secondary"
            title="Er ging iets mis"
            description="We konden je hypotheek niet berekenen. Probeer het opnieuw of neem contact met Huub."
            align="center"
          />
        </Flex>
      </Card>
    </Container>
  </Section>
);
